import { DuplicateItemQfm } from "./duplicate-item-qfm.model";

export class DuplicateItemQfmSections {
    title: string;
    questionnaires: DuplicateItemQfm[]

    constructor({
        title,
        questionnaires
    } : {
        title: string;
        questionnaires: DuplicateItemQfm[]
    }) {
        this.title = title;
        this.questionnaires = questionnaires;
    }
}